import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
import FileDownload from 'shared/FileDownload';
import moment   from 'moment'
 import json2csv   from 'json2csv'
import config from  '../../../../config';

import Select   from 'react-select'
  import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [

     {label: 'Type', value:'Type'},
     {label: 'Number', value:'PickupNumber'},
     {label: 'Service Date',  value: (row, field) => {

         return  moment(row.ServiceStartTime).format('MM-DD-YYYY')

     }},
     {label: 'Time', value:  (row, field) =>{
            if (row.TimeWindow &&  row.Type) {
                var foundItem = _.find(config.services.timeWindowOptions, {value: row.TimeWindow})
                return foundItem ? foundItem.label : row.TimeWindow;
            } else{
                return ''
            }
    }},

     {label: 'Status ',  value:   'Status' },
     {label: 'Location', value:'MarketName'},

     {label: 'Create Date',  value: (row, field) => {

         return  moment(row.createdAt).format('MM-DD-YYYY')

     }},

     {label: 'Seller Email', value:'UserID.email'},
     {label: 'Seller Payout', value:'SellerID.Payout'},


]

export default class ContractorReportsActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            reportFields:allReportFieldList
         };

    };




    downloadReport(){
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
         this.props.makeRequest({'records': this.props.adminServices.selectedRecords, reportType:'services' }, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
             var csvData = json2csv.parse(res.data, {
                 fields: fields,
              })

               var filename = "report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            console.log('err', err );
        });
    }

    onSelectTab(event){
         this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {

        return (
            <div className="action-block">
                <Tabs defaultActiveKey={''} onSelect={(e)=>{this.onSelectTab(e)}} id="sellerActionBox" >

                        <Tab eventKey={'reports'}  unmountOnExit={true} title="Reports" >
                            <Row className= {this.state.displayReportTab ? '':'hidden'}>
                                <Col md={4} xs={4} className="top10">
                                    <Select
                                        tabIndex="0"
                                        searchable ={true}
                                        multi
                                        selectedOptions
                                        clearable={false}
                                        placeholder="Included fields"
                                        options={allReportFieldList}
                                        onChange={ (selectedOptions)=> this.setState({'reportFields': selectedOptions})}
                                        //  filterOptions={filterOptions}
                                        value={this.state.reportFields}
                                    />
                                </Col>

                            </Row>
                            <Row>

                                <Col md={3} xs={6} className="top10">
                                     <button className="btn btn-primary" disabled={this.state.pending} onClick={ this.downloadReport.bind(this)}
                                            type="button">
                                        Download report
                                    </button>



                                </Col>
                            </Row>
                        </Tab>

                    </Tabs>

                </div >
        );

    }
}



